import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import backgroundImage from "../../assets/program-img3.jpg";
import cmsApi from "../../services/cmsApi";
import { getImageUrl } from "../../utils/getImageUrl";

function HistorySection() {
  const [historyData, setHistoryData] = useState({
    title: "FROM ROOTS TO REACH OUR JOURNEY IN IT EDUCATION",
    narrative: "JR Institute of Information technology (JRIIT) history is traced back to 1999 when JR Electronics LTD, a company dealing with IT communication and network branched itself to give a start to an education entity called JR Institute of Information Technology (JRIIT). Initially, JRIIT's scope of action was limited to training the workers (and candidates for employment) of the parental company. But soon JRIIT transformed itself into a fully Educational Institute embracing more local young people who were eager to learn new IT skills.",
    bgImage: backgroundImage,
    btn1Text: "OUR HISTORY",
    btn1Link: "/about",
    btn2Text: "OUR MISSION",
    btn2Link: "/about/mission",
    btn3Text: "OUR TEAM",
    btn3Link: "/about/trustees",
  });

  // Fetch history content from CMS (client-side only)
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const fetchHistoryContent = async () => {
      try {
        const result = await cmsApi.getHomepageComponentByType('history');
        if (result.success && result.components.length > 0) {
          const history = result.components[0];
          
          const defaultNarrative = "JR Institute of Information technology (JRIIT) history is traced back to 1999 when JR Electronics LTD, a company dealing with IT communication and network branched itself to give a start to an education entity called JR Institute of Information Technology (JRIIT). Initially, JRIIT's scope of action was limited to training the workers (and candidates for employment) of the parental company. But soon JRIIT transformed itself into a fully Educational Institute embracing more local young people who were eager to learn new IT skills.";
          
          setHistoryData({
            title: history.title || "FROM ROOTS TO REACH OUR JOURNEY IN IT EDUCATION",
            narrative: history.content || defaultNarrative,
            bgImage: history.mediaUrl || backgroundImage,
            btn1Text: history.ctaText || "OUR HISTORY",
            btn1Link: history.ctaLink || "/about",
            btn2Text: history.cta2Text || "OUR MISSION",
            btn2Link: history.cta2Link || "/about/mission",
            btn3Text: history.cta3Text || "OUR TEAM",
            btn3Link: history.cta3Link || "/about/trustees",
          });
        }
      } catch (error) {
        console.log('Using default history content:', error.message);
      }
    };

    fetchHistoryContent();
  }, []);

  return (
    <section
      className="history-section flex items-center justify-center min-h-[60vh] sm:min-h-[70vh] md:min-h-[80vh] bg-cover bg-center bg-opacity-50 relative"
      style={{
        backgroundImage: `url(${getImageUrl(historyData.bgImage)})`,
      }}
    >
      {/* Overlay for background image opacity */}
      <div className="absolute inset-0 bg-black opacity-50"></div>

      <div className="relative z-10 text-center p-6 sm:p-10 md:p-16 lg:p-20 xl:p-24 bg-white bg-opacity-80 rounded-lg shadow-lg w-full max-w-6xl mx-4 my-8 sm:my-12 md:my-16 min-[1024px]:max-[1535px]:!p-8 min-[1024px]:max-[1535px]:!my-10">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-custom-pink mb-6 min-[1024px]:max-[1535px]:!text-3xl min-[1024px]:max-[1535px]:!mb-4">
          {historyData.title}
        </h1>
        <span className="inline-block border-solid  border-b-4 border-gold mb-4 w-28 h-2 min-[1024px]:max-[1535px]:!mb-3 min-[1024px]:max-[1535px]:!w-24 min-[1024px]:max-[1535px]:!border-b-2"></span>

        <p className="text-base sm:text-lg text-gray-800 tracking-wide w-full max-w-[900px] text-justify mx-auto leading-relaxed mb-6 px-4 min-[1024px]:max-[1535px]:!text-sm">
          {historyData.narrative}
        </p>

        {/* Buttons */}
        <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mt-6 sm:mt-8 min-[1024px]:max-[1535px]:!gap-3 min-[1024px]:max-[1535px]:!mt-5">
          {historyData.btn1Text && historyData.btn1Link && (
            <Link
              to={historyData.btn1Link}
              className="bg-transparent border border-custom-pink text-custom-pink py-2 sm:py-3 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-20 rounded-full transition-all duration-300 hover:bg-custom-pink hover:text-white hover:border-custom-pink min-[1024px]:max-[1535px]:!py-2 min-[1024px]:max-[1535px]:!px-6 min-[1024px]:max-[1535px]:!text-sm"
            >
              {historyData.btn1Text}
            </Link>
          )}
          {historyData.btn2Text && historyData.btn2Link && (
            <Link
              to={historyData.btn2Link}
              className="bg-transparent border border-custom-pink text-custom-pink py-2 sm:py-3 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-20 rounded-full transition-all duration-300 hover:bg-custom-pink hover:text-white hover:border-custom-pink min-[1024px]:max-[1535px]:!py-2 min-[1024px]:max-[1535px]:!px-6 min-[1024px]:max-[1535px]:!text-sm"
            >
              {historyData.btn2Text}
            </Link>
          )}
          {historyData.btn3Text && historyData.btn3Link && (
            <Link
              to={historyData.btn3Link}
              className="bg-transparent border border-custom-pink text-custom-pink py-2 sm:py-3 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-20 rounded-full transition-all duration-300 hover:bg-custom-pink hover:text-white hover:border-custom-pink min-[1024px]:max-[1535px]:!py-2 min-[1024px]:max-[1535px]:!px-6 min-[1024px]:max-[1535px]:!text-sm"
            >
              {historyData.btn3Text}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}

export default HistorySection;
